import { call, put, takeLatest } from 'redux-saga/effects';
import {
  NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO,
  NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_PENDING,
  NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_SUCCESS,
  NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_FAILURE,
} from '../../actionTypes';
import { conciliacaoBancariaService } from '../../service';
import { AlertError } from '@components/common/AlertToast';

function* sagaNewFilterContasRecorrentes(action) {
  try {
    yield put({ type: NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_PENDING });

    const { propriedadeId, dataInicio, dataFim, page = 0, size = 10 } = action.args || action;

    const response = yield call(
      conciliacaoBancariaService.buscarContasRecorrentesPendentes,
      propriedadeId,
      dataInicio,
      dataFim,
      page,
      size
    );

    // A API pode retornar os dados em response.data ou diretamente em response
    const responseData = response.data || response;

    yield put({
      type: NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_SUCCESS,
      response: responseData,
      args: { propriedadeId, dataInicio, dataFim, page, rows: size }
    });

  } catch (error) {
    yield put({
      type: NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_FAILURE,
      error: error.message || 'Erro ao buscar contas recorrentes'
    });

    const errorMessage = error.response?.data?.message || error.message || 'Erro ao buscar contas recorrentes';
    AlertError(errorMessage);
  }
}

export default function* watchNewFilterContasRecorrentes() {
  yield takeLatest(NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO, sagaNewFilterContasRecorrentes);
}
